module.exports = __webpack_public_path__ + "static/media/Avatar.e9a678e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Avatar.jpg
// module id = 517
// module chunks = 0